import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import React from 'react';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var StepProgress = styled__default('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n\n  &:before,\n  &:after {\n    content: '';\n    height: 0.3rem;\n    flex: 1;\n    margin-top: 0.9rem;\n  }\n\n  &:before {\n    background-color: ", ";\n  }\n\n  &:after {\n    background-color: white;\n  }\n\n\n  &:before {\n    display: none\n  }\n"])), function (_ref) {
  var completed = _ref.completed,
    active = _ref.active,
    theme = _ref.theme;
  return completed || active ? theme.palette.secondary : theme.palette.grayDarker;
});
var StepDetails = styled__default('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var StepCircleWrapper = styled__default('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n\n  &:before,\n  &:after {\n    content: '';\n    height: 0.3rem;\n    flex: 1;\n    margin-top: 0.9rem;\n  }\n\n  &:before {\n    background-color: ", ";\n  }\n\n  &:after {\n    background-color: ", ";\n  }\n"])), function (_ref2) {
  var completed = _ref2.completed,
    active = _ref2.active,
    theme = _ref2.theme;
  return completed || active ? theme.palette.secondary : theme.palette.grayDarker;
}, function (_ref3) {
  var completed = _ref3.completed,
    theme = _ref3.theme;
  return completed ? theme.palette.secondary : theme.palette.grayDarker;
});
var StepCircle = styled__default('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  border: 0.3rem solid\n    ", ";\n  color: ", ";\n  background-color: ", ";\n  width: 1.6rem;\n  height: 1.6rem;\n  line-height: 1.6rem;\n  box-sizing: content-box;\n  text-align: center;\n  display: inline-block;\n"])), function (_ref4) {
  var completed = _ref4.completed,
    active = _ref4.active,
    theme = _ref4.theme;
  return completed || active ? theme.palette.secondary : theme.palette.grayDarker;
}, function (_ref5) {
  var completed = _ref5.completed,
    active = _ref5.active,
    theme = _ref5.theme;
  return completed || active ? theme.palette.secondary : theme.palette.grayDarker;
}, function (_ref6) {
  var completed = _ref6.completed,
    theme = _ref6.theme;
  return completed ? theme.palette.secondary : 'white';
});
var StepCircleTitle = styled__default('span')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: 0.6rem;\n  display: block;\n  text-align: center;\n  max-width: 6rem;\n"])), function (_ref7) {
  var completed = _ref7.completed,
    active = _ref7.active,
    theme = _ref7.theme;
  return completed || active ? 'black' : theme.palette.grayDarker;
});
var CircleStepWrapper = styled__default('div')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
var CircleStepDetails = styled__default('div')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  @media (max-width: 500px) {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 1rem;\n  }\n"])));
var CircleStep = styled__default('div')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 1.25rem;\n  height: 1.25rem;\n  box-sizing: content-box;\n  text-align: center;\n  display: inline-block;\n  font-family: 'Roboto Bold', 'Roboto Regular', 'Roboto', sans-serif;\n  font-size: 14px;\n  line-height: 1.25rem;\n  font-weight: bold;\n  border-radius: 50%;\n  border: 0.15rem solid;\n\n  border-color: ", ";\n\n  background-color: ", ";\n\n  color: ", ";\n"])), function (_ref8) {
  var completed = _ref8.completed,
    active = _ref8.active,
    theme = _ref8.theme;
  if (completed) {
    return theme.stepper.step.completed.borderColor;
  } else if (active) {
    return theme.stepper.step.active.borderColor;
  } else {
    return theme.palette.gray;
  }
}, function (_ref9) {
  var active = _ref9.active,
    theme = _ref9.theme,
    completed = _ref9.completed;
  if (completed) {
    return theme.stepper.step.completed.backgroundColor;
  } else if (active) {
    return theme.stepper.step.active.backgroundColor;
  } else {
    return theme.palette.white;
  }
}, function (_ref10) {
  var completed = _ref10.completed,
    active = _ref10.active,
    theme = _ref10.theme;
  if (completed || active) {
    return theme.palette.white;
  } else {
    return theme.palette.gray;
  }
});
var CircleStepTitle = styled__default('span')(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-style: italic;\n  display: inline-block;\n  text-align: left;\n  font-weight: bold;\n  font-family: 'Roboto Medium Italic', 'Roboto Regular', 'Roboto', sans-serif;\n  font-size: 14px;\n  margin-top: 0.6rem;\n\n  color: ", ";\n\n  @media (max-width: 500px) {\n    margin-top: 0;\n    margin-left: 1rem;\n  }\n"])), function (_ref11) {
  var completed = _ref11.completed,
    active = _ref11.active,
    theme = _ref11.theme;
  if (completed) {
    return theme.palette.secondaryDark;
  } else if (active) {
    return theme.palette.primary;
  } else {
    return theme.palette.gray;
  }
});
var Checkmark = styled__default('div')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 0.6rem;\n  width: 0.3rem;\n  border-bottom: 0.15rem solid white;\n  border-right: 0.15rem solid white;\n"])));
var LFGStyleCheckMark = styled__default(Checkmark)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  margin-right: 0.3rem;\n"])));
var StepIndicator = styled__default('div')(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  display: inline-block;\n  flex: auto;\n  font-size: 0.75rem;\n  margin-right: 0.0325rem;\n  padding: 0.5rem 1rem;\n  position: relative;\n  text-align: center;\n  &:after,\n  &:before {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 0;\n    height: 0;\n  }\n  &:after {\n    border-top: 1rem solid #fff;\n    border-bottom: 0.9rem solid #fff;\n    border-left: ", ";\n  }\n  &:before {\n    right: auto;\n    left: 0;\n    border-bottom: ", ";\n    border-top: ", ";\n    border-left: 0.3rem solid #fff;\n  }\n  &:first-child {\n    &:before {\n      display: none;\n    }\n  }\n  &:last-child {\n    &:after {\n      display: none;\n    }\n  }\n  @media (max-width: 500px) {\n    margin-right: 0.25rem;\n    &:before,\n    &:after {\n      display: none;\n    }\n  }\n"])), function (_ref12) {
  var completed = _ref12.completed,
    active = _ref12.active,
    theme = _ref12.theme;
  return active ? theme.stepper.step.active.backgroundColor : completed ? theme.stepper.step.completed.backgroundColor : theme.palette.grayLighter;
}, function (_ref13) {
  var completed = _ref13.completed,
    active = _ref13.active,
    theme = _ref13.theme;
  return active || completed ? theme.palette.grayLightest : theme.palette.grayDarkest;
}, function (_ref14) {
  var completed = _ref14.completed,
    active = _ref14.active,
    theme = _ref14.theme;
  return active ? theme.stepper.step.active.borderLeft : completed ? theme.stepper.step.completed.borderLeft : "0.3rem solid ".concat(theme.palette.grayLighter);
}, function (_ref15) {
  var completed = _ref15.completed,
    active = _ref15.active,
    theme = _ref15.theme;
  return active ? theme.stepper.step.active.borderBottom : completed ? theme.stepper.step.completed.borderBottom : "0.9rem solid  ".concat(theme.palette.grayLighter);
}, function (_ref16) {
  var completed = _ref16.completed,
    active = _ref16.active,
    theme = _ref16.theme;
  return active ? theme.stepper.step.active.borderTop : completed ? theme.stepper.step.completed.borderTop : "0.9rem solid  ".concat(theme.palette.grayLighter);
});
var ProgressCircle = function ProgressCircle(_ref17) {
  var completed = _ref17.completed,
    active = _ref17.active,
    title = _ref17.title,
    stepNumber = _ref17.stepNumber,
    totalSteps = _ref17.totalSteps;
  return /*#__PURE__*/React.createElement(StepProgress, {
    completed: completed,
    role: "listitem",
    active: active
  }, /*#__PURE__*/React.createElement(CircleStepDetails, null, /*#__PURE__*/React.createElement(CircleStepWrapper, {
    stepNumber: stepNumber
  }, /*#__PURE__*/React.createElement(CircleStep, {
    active: active,
    completed: completed
  }, stepNumber)), /*#__PURE__*/React.createElement(CircleStepTitle, {
    active: active,
    completed: completed
  }, title)));
};

export default ProgressCircle;
